import { CacheProvider } from "@emotion/react";
import PropTypes from "prop-types";
import { ErrorBoundary } from "react-error-boundary";

import { emotionCache } from "../../helpers/emotionCache";
import { errorHandler } from "../../helpers/errorHandler";
import { FallbackComponent } from "../general/FallbackComponent";
import { RoutesProvider } from "./RoutesProvider";

export const AppProviders = ({ children }) => (
	<ErrorBoundary onError={errorHandler} FallbackComponent={FallbackComponent}>
		<CacheProvider value={emotionCache}>
			<RoutesProvider>{children}</RoutesProvider>
		</CacheProvider>
	</ErrorBoundary>
);

AppProviders.propTypes = {
	children: PropTypes.node.isRequired,
};
